<template>
	<div>
		<case-form :schema="schemaShared" class="mt6" />
		<case-form :schema="schemaLiabilities" class="mt6" />
		<case-form :schema="schemaExtra" class="mt6" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
export default {
	components: {
		CaseForm
	},

	computed: {
		schemaShared() {
			return [
				{
					label: `Is Income statement shared? (Liabilities)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0liabilitiesIsShared`,
					props: {
						suggest: {
							typeIncludes: `liabilitiesIsShared`
						},
						createOptions: {
							type: `liabilitiesIsShared`,
							dataType: "boolean"
						}
					}
				},
				{
					component: "html",
					props: {
						content: `<div class='fs4 fw7 lh125'>If "yes" answer the questions below</div>`
					},
					bindTo: ""
				},
				{
					label: `Shared with (Indiciate Relationship):`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0liabilitiesSharedWith`,
					props: {
						suggest: {
							typeIncludes: `liabilitiesSharedWith`
						},
						createOptions: {
							type: `liabilitiesSharedWith`,
							dataType: "string"
						}
					}
				},
				{
					label: `Portion earned by Client (%)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0liabilitiesSharedRatio`,
					props: {
						suggest: {
							typeIncludes: `liabilitiesSharedRatio`
						},
						createOptions: {
							type: `liabilitiesSharedRatio`,
							dataType: "number"
						}
					}
				}
			]
		},

		schemaLiabilities() {
			return [
				{
					label: `Personal Loans (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0liabilitiesPersonalLoans`,
					props: {
						suggest: {
							typeIncludes: `liabilitiesPersonalLoans`
						},
						createOptions: {
							type: `liabilitiesPersonalLoans`,
							dataType: "number"
						}
					}
				},
				{
					label: `Margin Account (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0liabilitiesMarginAccount`,
					props: {
						suggest: {
							typeIncludes: `liabilitiesMarginAccount`
						},
						createOptions: {
							type: `liabilitiesMarginAccount`,
							dataType: "number"
						}
					}
				},
				{
					label: `Loan Guarantees (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0liabilitiesLoanGuarantees`,
					props: {
						suggest: {
							typeIncludes: `liabilitiesLoanGuarantees`
						},
						createOptions: {
							type: `liabilitiesLoanGuarantees`,
							dataType: "number"
						}
					}
				},
				{
					label: `Mortgages (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0liabilitiesMortgages`,
					props: {
						suggest: {
							typeIncludes: `liabilitiesMortgages`
						},
						createOptions: {
							type: `liabilitiesMortgages`,
							dataType: "number"
						}
					}
				},
				{
					label: `Other (please specify) (USD)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0liabilitiesOther`,
					props: {
						suggest: {
							typeIncludes: `liabilitiesOther`
						},
						createOptions: {
							type: `liabilitiesOther`,
							dataType: "number"
						}
					}
				},
				{
					label: `Total Liabilities`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0liabilitiesTotal`,
					props: {
						suggest: {
							typeIncludes: `liabilitiesTotal`
						},
						createOptions: {
							type: `liabilitiesTotal`,
							dataType: "number"
						}
					}
				}
			]
		},

		schemaExtra() {
			return [
				{
					label: `Is purpose of insurance related to business?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0isPurposeOfInsuranceRelatedToBusiness`,
					props: {
						suggest: {
							typeIncludes: `isPurposeOfInsuranceRelatedToBusiness`
						},
						createOptions: {
							type: `isPurposeOfInsuranceRelatedToBusiness`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `In the last 5 years, have you declared or been petitioned into personal or corporate bankruptcy?`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasDeclaredOrPetitionedForBankruptcy`,
					props: {
						suggest: {
							typeIncludes: `hasDeclaredOrPetitionedForBankruptcy`
						},
						createOptions: {
							type: `hasDeclaredOrPetitionedForBankruptcy`,
							dataType: "boolean"
						}
					}
				},
				{
					label: `If “Yes,” please provide dates and details:`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0bankruptcyDetails`,
					props: {
						suggest: {
							typeIncludes: `bankruptcyDetails`
						},
						createOptions: {
							type: `bankruptcyDetails`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
